import { datadogRum } from '@datadog/browser-rum'
import { vuePlugin } from '@datadog/browser-rum-vue'

export function initDatadog() {
  const applicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID
  const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN

  if (!applicationId || !clientToken) return

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'us5.datadoghq.com',
    service: import.meta.env.VITE_DATADOG_SERVICE ?? 'corpo-2.0',
    env: import.meta.env.VITE_DATADOG_ENV ?? 'development',
    version: import.meta.env.VITE_SENTRY_RELEASE ?? '0.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    trackResources: false,
    trackLongTasks: false,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [vuePlugin({ router: true })],
  })
}

export function trackDatadogAction(name: string, context?: Record<string, unknown>) {
  datadogRum.addAction(name, context)
}

export function setDatadogGlobalContextProperty(key: string, value: unknown) {
  datadogRum.setGlobalContextProperty(key, value)
}
